import Swiper from 'swiper/bundle';

export default () => {
  let allHtml = document.querySelector('html');
  const carouselsWithModal = document.querySelectorAll('.js-carouselsWithModal');
  const carouselSliders = document.querySelectorAll('.js-CarouselSlider[data-type="modal"]');

  carouselsWithModal.forEach(carouselWithModal => {
    carouselSliders.forEach(slider => {
      const openModals = slider.querySelectorAll('.js-openModal');
      const modal = carouselWithModal.querySelector('.js-CarouselModal');
      const closenModal = carouselWithModal.querySelector('.js-ModalClose');
      
      openModals.forEach(openModal => {
        openModal.addEventListener('click', function(el) { 
          el.preventDefault();
          allHtml.style.overflow = 'hidden';
          modal.classList.add('is-modal-open');
          carouselWithModal.classList.add('is-modal-open');
  
          const cardTrigger = this.parentNode;
          const cardWrapper = cardTrigger.parentNode;
          const card = cardWrapper.parentNode;
          const swiperItem = card.parentNode;
          
          const cardIndex = Array.prototype.indexOf.call(swiperItem.parentNode.children, swiperItem);
  
          // SWIPER MODALE
          const modalSlider = modal.querySelector('.js-ModalSlider');
          if(modalSlider){
              let modalSwiper = new Swiper(modalSlider, {
                slidesPerView: 1, 
                initialSlide: cardIndex,
                navigation: {
                  nextEl: ".swiper-button-next",
                  prevEl: ".swiper-button-prev",
                },
              }); 
              closenModal.addEventListener('click', function(){
                modal.classList.remove('is-modal-open');
                carouselWithModal.classList.remove('is-modal-open');
                allHtml.style.overflow = 'auto'; 
                modalSwiper.destroy(true, true);
              });
          }
        })
      }); 
  
    }); 
  })
  
}

